export interface CentralSiteIdentity {
  authenticated: boolean
  role: 'admin' | 'mod' | 'none'
}

export async function readCentralSiteIdentity(fetcher: typeof fetch = fetch, signal?: AbortSignal): Promise<CentralSiteIdentity | null> {
  try {
    const response = await fetcher('https://sanctions.extracraft.net/api/site-navigation', {
      method: 'GET', credentials: 'include', cache: 'no-store', signal,
    })
    if (!response.ok) return null
    const proof = await response.json() as Partial<CentralSiteIdentity> | null
    if (typeof proof?.authenticated !== 'boolean' || !['admin', 'mod', 'none'].includes(proof.role ?? '')) return null
    return { authenticated: proof.authenticated, role: proof.role as CentralSiteIdentity['role'] }
  } catch {
    return null
  }
}
